import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';
import { KpiFilters } from '../../models/kpi-filters.model';
import { KpiService } from '../../services/kpi.service';

@Component({
  selector: 'app-kpi-tolerance-breach',
  templateUrl: './kpi-tolerance-breach.component.html',
  styleUrl: './kpi-tolerance-breach.component.scss',
  standalone: false,
})
export class KpiToleranceBreachComponent implements OnChanges {
  @Input() filters: KpiFilters = {};

  loading = false;

  chartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        label: 'Règles hors tolérance',
        data: [],
        backgroundColor: '#f59e0b',
      },
      {
        label: 'Règles dans la tolérance',
        data: [],
        backgroundColor: '#94a3b8',
      },
    ],
  };

  chartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    plugins: { legend: { position: 'top' } },
    scales: {
      x: { stacked: true },
      y: { stacked: true, beginAtZero: true },
    },
  };

  constructor(private kpiService: KpiService) {}

  ngOnChanges(_changes: SimpleChanges): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.kpiService.getToleranceBreachCoverage(this.filters).subscribe({
      next: (response) => {
        this.chartData = {
          labels: response.dataPoints.map((p) =>
            new Date(p.snapshotDate).toLocaleDateString(),
          ),
          datasets: [
            {
              label: 'Règles hors tolérance',
              data: response.dataPoints.map((p) => p.rulesWithToleranceBreach),
              backgroundColor: '#f59e0b',
            },
            {
              label: 'Règles dans la tolérance',
              data: response.dataPoints.map(
                (p) => p.totalRules - p.rulesWithToleranceBreach,
              ),
              backgroundColor: '#94a3b8',
            },
          ],
        };
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
